<template>
  <div class="aw-about-us aw-news-index">
    <div class="com-sub-top">
      <div class="title container-center">企业新闻</div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>
